export { default } from './ReturnUserModule.vue';